module.exports = __webpack_public_path__ + "static/stacja-kopernik-b91f0fe98aa9cdd484d9ac1a9ed06332.png";